import React from "react";
import { noop } from "@client/shared/constants";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";

import WarningDialog from "../warning";

import { globalStyles } from "@client/shared/constants";
import style from "./style";

const DIALOG_DIMENSION = {
  0: { minWidth: 720, minHeight: 460 },
  1: { minWidth: 720, minHeight: 460 },
  2: { minWidth: 720, minHeight: 460 },
  3: { minWidth: 620, minHeight: 460 },
  4: { minWidth: 720, minHeight: 460 },
  5: { minWidth: 720, minHeight: 460 },
  6: { minWidth: 500, minHeight: 160 },
};

const CreateBroadcastView = ({
  panelIndex = 0,
  immediateRelease = false,
  isSaving = false,
  isEditing = false,
  showDetails = false,
  isScheduled = false,
  roleAccess = {},
  panel = {
    title: "",
    component: <></>,
  },
  onClose = noop,
  handlePanelNavigate = noop,
  handleClose = noop,
  validate = noop,
  validateFields = noop,
  userData = {},
  isCancelling = false,
  handleConfirmation = noop,
  handleDelete = noop,
  broadcastComplete = false,
}) => {
  return (
    <>
      <Dialog
        open
        onClose={() => onClose(broadcastComplete)}
        sx={{
          ...style.dialog(DIALOG_DIMENSION[panelIndex]),
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.between,
            }}
          >
            <Typography
              variant="h6"
              color="secondary"
              sx={{
                ...globalStyles.text.weight.bold,
              }}
            >
              {panel.title}
            </Typography>
            <CloseIcon
              sx={{
                ...globalStyles.cursor.pointer,
                ...style.closeIcon,
                color: '#B0B0B0'
              }}
              onClick={() => handleClose(broadcastComplete)}
              disabled={isSaving}
            />
          </Box>
        </DialogTitle>
        <DialogContent sx={panelIndex === 5 && { mt: 4 }}>
          {panel.component}
        </DialogContent>
        <DialogActions
          sx={{
            py: 2,
            ...style.dialogAction,
          }}
        >
          <Box>
            {showDetails && isScheduled && roleAccess.sendBroadcasts && (
              <Button
                variant="contained"
                sx={{
                  mx: 2,
                  px: 4,
                  ...style.releaseBtn,
                }}
                onClick={() => {
                  if (!userData.cancelPreference) {
                    handleConfirmation(true);
                  } else {
                    handleDelete();
                  }
                }}
              >
                Cancel Release
              </Button>
            )}
            {panelIndex !== 0 && (
              <Button
                disabled={isSaving}
                variant={
                  showDetails || panelIndex === 6 || broadcastComplete
                    ? "contained"
                    : "simple"
                }
                startIcon={
                  !showDetails &&
                  panelIndex !== 6 &&
                  !broadcastComplete && <ArrowBackIcon />
                }
                onClick={() =>
                  showDetails || broadcastComplete
                    ? handleClose(broadcastComplete)
                    : handlePanelNavigate("back", panelIndex)
                }
                sx={
                  showDetails
                    ? {
                        px: 6,
                      }
                    : {}
                }
              >
                {showDetails || broadcastComplete
                  ? "Close"
                  : panelIndex === 6
                  ? "Cancel"
                  : "Back"}
              </Button>
            )}
            {!showDetails && panelIndex !== 6 && !broadcastComplete && (
              <Button
                disabled={!validate(panelIndex) || validateFields() || isSaving}
                variant="contained"
                sx={{
                  mx: 2,
                  px: 4,
                }}
                onClick={() => {
                  handlePanelNavigate("next", panelIndex);
                }}
              >
                {isSaving ? (
                  <CircularProgress size={20} />
                ) : panelIndex === 5 ? (
                  isEditing ? (
                    "Update"
                  ) : immediateRelease ? (
                    "Release"
                  ) : (
                    "Schedule"
                  )
                ) : (
                  "Next"
                )}
              </Button>
            )}
            {!userData.cancelPreference && isCancelling && (
              <WarningDialog
                isOpen={isCancelling}
                onClose={() => handleConfirmation(false)}
                content="Cancelling this release will remove all it's information and audio files from your account."
                handleDelete={handleDelete}
                userData={userData}
                positiveLabel="Continue"
                userPreference={userData.cancelPreference}
                preferenceName="cancelPreference"
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateBroadcastView;
